var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04427 6.00255L7.86093 2.90584C7.95673 2.80051 8.00304 2.67587 7.99985 2.53192C7.99665 2.38797 7.94715 2.26333 7.85135 2.158C7.75554 2.05267 7.64217 2 7.51124 2C7.38031 2 7.26694 2.05267 7.17114 2.158L4.22993 5.40217C4.15329 5.48643 4.0958 5.58123 4.05748 5.68656C4.01916 5.79189 4 5.89722 4 6.00255C4 6.10788 4.01916 6.21321 4.05748 6.31854C4.0958 6.42387 4.15329 6.51867 4.22993 6.60293L7.18071 9.8471C7.27652 9.95243 7.38829 10.0033 7.51603 9.99983C7.64377 9.99632 7.75554 9.9419 7.85135 9.83657C7.94715 9.73124 7.99505 9.6066 7.99505 9.46265C7.99505 9.31869 7.94715 9.19405 7.85135 9.08872L5.04427 6.00255Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftS);
export default __webpack_public_path__ + "static/media/arrow-left-s.0aede735a3e75fba2d26fc8a772cde2d.svg";
export { ForwardRef as ReactComponent };